import { ReactElement } from 'react';
import '@assets/styles/pages/today-meeting-details.scss';
import { ConductedMeeting } from '@components/conductedMeetings/conductedMeetings';

export const ConductedMeetingsPage = (): ReactElement => {
	return <ConductedMeeting />;
};
